module.exports = __webpack_public_path__ + "img/login3.775fb954.png";